import React from "react";
import {
	IconArchive,
	IconFileCode,
	IconFileExcel,
	IconFileTypePdf,
	IconFileWord,
	IconPhoto,
	IconVideo,
	IconMailFilled,
	IconFileTypography,
	IconFileTypePpt,
	IconVolume,
	IconFileTypeTxt,
} from "@tabler/icons-react";

export function getFileIconMap(defaultIconProps) {
	return {
		pdf: {
			icon: "file-pdf",
			iconComponent: (
				<IconFileTypePdf color="red" {...defaultIconProps} />
			),
		},

		doc: {
			icon: "file-word",
			iconComponent: (
				<IconFileWord color="#335290" {...defaultIconProps} />
			),
		},
		docx: {
			icon: "file-word",
			iconComponent: (
				<IconFileWord color="#335290" {...defaultIconProps} />
			),
		},

		xls: {
			icon: "file-excel",
			iconComponent: (
				<IconFileExcel color="#3b714b" {...defaultIconProps} />
			),
		},
		xlsx: {
			icon: "file-excel",
			iconComponent: (
				<IconFileExcel color="#3b714b" {...defaultIconProps} />
			),
		},

		ppt: {
			icon: "file-powerpoint",
			iconComponent: (
				<IconFileTypePpt color="red" {...defaultIconProps} />
			),
		},
		pptx: {
			icon: "file-powerpoint",
			iconComponent: (
				<IconFileTypePpt color="#F56942" {...defaultIconProps} />
			),
		},

		mov: {
			icon: "file-video",
			iconComponent: <IconVideo color="red" {...defaultIconProps} />,
		},
		wmv: {
			icon: "file-video",
			iconComponent: <IconVideo color="red" {...defaultIconProps} />,
		},
		mp4: {
			icon: "file-video",
			iconComponent: <IconVideo color="red" {...defaultIconProps} />,
		},
		avi: {
			icon: "file-video",
			iconComponent: <IconVideo color="red" {...defaultIconProps} />,
		},
		webm: {
			icon: "file-video",
			iconComponent: <IconVideo color="red" {...defaultIconProps} />,
		},
		avchd: {
			icon: "file-video",
			iconComponent: <IconVideo color="red" {...defaultIconProps} />,
		},

		jpg: {
			icon: "file-image",
			iconComponent: <IconPhoto color="green" {...defaultIconProps} />,
		},
		jpeg: {
			icon: "file-image",
			iconComponent: <IconPhoto color="green" {...defaultIconProps} />,
		},
		png: {
			icon: "file-image",
			iconComponent: <IconPhoto color="green" {...defaultIconProps} />,
		},
		bmp: {
			icon: "file-image",
			iconComponent: <IconPhoto color="green" {...defaultIconProps} />,
		},
		tif: {
			icon: "file-image",
			iconComponent: <IconPhoto color="green" {...defaultIconProps} />,
		},
		tiff: {
			icon: "file-image",
			iconComponent: <IconPhoto color="green" {...defaultIconProps} />,
		},
		webp: {
			icon: "file-image",
			iconComponent: <IconPhoto color="green" {...defaultIconProps} />,
		},
		svg: {
			icon: "file-image",
			iconComponent: <IconPhoto color="green" {...defaultIconProps} />,
		},
		gif: {
			icon: "file-image",
			iconComponent: <IconPhoto color="green" {...defaultIconProps} />,
		},

		wav: {
			icon: "file-audio",
			iconComponent: <IconVolume color="grey" {...defaultIconProps} />,
		},
		mp3: {
			icon: "file-audio",
			iconComponent: <IconVolume color="grey" {...defaultIconProps} />,
		},
		ogg: {
			icon: "file-audio",
			iconComponent: <IconVolume color="grey" {...defaultIconProps} />,
		},
		flac: {
			icon: "file-audio",
			iconComponent: <IconVolume color="grey" {...defaultIconProps} />,
		},
		m4a: {
			icon: "file-audio",
			iconComponent: <IconVolume color="grey" {...defaultIconProps} />,
		},
		mid: {
			icon: "file-audio",
			iconComponent: <IconVolume color="grey" {...defaultIconProps} />,
		},
		midi: {
			icon: "file-audio",
			iconComponent: <IconVolume color="grey" {...defaultIconProps} />,
		},

		eml: {
			icon: "envelope",
			iconComponent: (
				<IconMailFilled color="grey" {...defaultIconProps} />
			),
		},
		msg: {
			icon: "envelope",
			iconComponent: (
				<IconMailFilled color="grey" {...defaultIconProps} />
			),
		},

		zip: {
			icon: "file-archive",
			iconComponent: <IconArchive color="grey" {...defaultIconProps} />,
		},

		csv: {
			icon: "file-csv",
			iconComponent: (
				<IconFileTypography color="grey" {...defaultIconProps} />
			),
		},

		js: {
			icon: "file-code",
			iconComponent: <IconFileCode color="grey" {...defaultIconProps} />,
		},
		html: {
			icon: "file-code",
			iconComponent: <IconFileCode color="grey" {...defaultIconProps} />,
		},
		json: {
			icon: "file-code",
			iconComponent: <IconFileCode color="grey" {...defaultIconProps} />,
		},
		css: {
			icon: "file-code",
			iconComponent: <IconFileCode color="grey" {...defaultIconProps} />,
		},
		htm: {
			icon: "file-code",
			iconComponent: <IconFileCode color="grey" {...defaultIconProps} />,
		},
		py: {
			icon: "file-code",
			iconComponent: <IconFileCode color="grey" {...defaultIconProps} />,
		},
		c: {
			icon: "file-code",
			iconComponent: <IconFileCode color="grey" {...defaultIconProps} />,
		},
		h: {
			icon: "file-code",
			iconComponent: <IconFileCode color="grey" {...defaultIconProps} />,
		},
		txt: {
			icon: "file-text",
			iconComponent: (
				<IconFileTypeTxt color="black" {...defaultIconProps} />
			),
		},
	};
}
